import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Row, Col, Select } from "antd";
import { fetchCities, fetchStates, fetchCountries } from "../../Services/user";
import CustomSelectField from "../../Component/CustomSelectField";

const EditUserModal = ({ visible, onClose, user, onUpdate, loading }) => {
  const [form] = Form.useForm();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    if (user && visible === true) {
      form.setFieldsValue({
        name: user.name || `${user.first_name || ""} ${user.last_name || ""}`.trim(),
        phone: user.phone_number,
        country_id: user.country_id,
        state_id: user.state_id,
        city_id: user.city_id,
        gender: user.gender,
      });
      setSelectedCountry({ label: user?.country_name, id: user?.country_id });
      setSelectedState({ label: user?.state_name, id: user?.state_id });
      setSelectedCity({ label: user?.city_name, id: user?.city_id });
    }
  }, [user, form, visible]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await onUpdate(user?.id, values);
    } catch (error) {
      console.log("Validate Failed:", error);
    }
  };

  const handleCancel = () => {
    form.resetFields(); // Clears the form fields
    onClose(); // Close the modal
  };

  return (
    <Modal
      title="Edit User"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Full Name"
              name="name"
              rules={[{ required: true, message: "Please enter Full Name" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Mobile Number"
              name="phone"
              rules={[
                { required: true, message: "Please enter Mobile Number" },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Gender"
              name="gender"
              rules={[{ required: true, message: "Please select Gender" }]}
            >
              <Select placeholder="Select Gender">
                <Select.Option value="male">Male</Select.Option>
                <Select.Option value="female">Female</Select.Option>
                <Select.Option value="other">Other</Select.Option>
                <Select.Option value="prefer_not_to_say">Prefer not to say</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Country Select */}
          <Col span={12}>
            <Form.Item
              label="Country"
              name="country_id"
              rules={[{ required: true, message: "Please select a country" }]}
            >
              <CustomSelectField
                fetchOptions={fetchCountries}
                label="Country"
                onChange={(value) => {
                  form.setFieldsValue({
                    country_id: value,
                    state_id: null,
                    city_id: null,
                  });
                }}
                initialValue={selectedCountry}
              />
            </Form.Item>
          </Col>

          {/* State Select */}
          <Col span={12}>
            <Form.Item
              label="State"
              name="state_id"
              rules={[{ required: true, message: "Please select a state" }]}
            >
              <CustomSelectField
                fetchOptions={(page, name) => {
                  if (form.getFieldValue("country_id")) {
                    return fetchStates(
                      page,
                      name,
                      form.getFieldValue("country_id")
                    );
                  }
                  return [];
                }}
                label="State"
                onChange={(value) => {
                  form.setFieldsValue({ state_id: value, city_id: null });
                }}
                initialValue={selectedState}
                dependentValue={form.getFieldValue("country_id")}
              />
            </Form.Item>
          </Col>

          {/* City Select */}
          <Col span={12}>
            <Form.Item
              label="City"
              name="city_id"
              rules={[{ required: true, message: "Please select a city" }]}
            >
              <CustomSelectField
                fetchOptions={(page, name) => {
                  if (form.getFieldValue("state_id")) {
                    return fetchCities(
                      page,
                      name,
                      form.getFieldValue("state_id")
                    );
                  }
                  return [];
                }}
                label="City"
                onChange={(value) => {
                  form.setFieldsValue({ city_id: value });
                }}
                initialValue={selectedCity}
                dependentValue={form.getFieldValue("state_id")}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item className="flex justify-end">
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
